<template>
    <router-view />
</template>

<script>
export default {
	name: 'App',
	created() {
		if (!this.$store.state.user.data) {
			this.$store.dispatch('user/fetch').catch(() => {
				// Handle the case where the user is not authenticated
			});
		}
	}
};
</script>

<style lang="postcss">
@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
    html, body, #app {
        @apply h-full;
    }
}
</style>
